import i18n from 'i18n';
import { COMMON_GRID_COLUMN_FIELD_NAMES } from '../../shared/commonGrid/grid-enums';

export default [
  {
    headerName: '',
    field: COMMON_GRID_COLUMN_FIELD_NAMES.Action,
    cellRenderer: 'actionMenuCellRenderer',
  },
  {
    headerName: i18n.t('warrant.attachment.name'),
    field: 'name',
    filter: 'agTextColumnFilter',
    sortable: true,
    resizable: true,
    tooltipField: 'name',
  },
  {
    headerName: i18n.t('warrant.attachment.description'),
    field: 'description',
    filter: 'agTextColumnFilter',
    sortable: true,
    resizable: true,
    tooltipField: 'description',
  },
  {
    headerName: i18n.t('warrant.attachment.size'),
    field: 'size',
    filter: 'agTextColumnFilter',
    sortable: true,
    resizable: true,
    tooltipField: 'description',
  },
  {
    headerName: i18n.t('warrant.attachment.owner'),
    field: 'owner.name',
    filter: 'agTextColumnFilter',
    sortable: true,
    resizable: true,
    tooltipField: 'description',
  },
];
